module.exports = __webpack_public_path__ + "static/media/workspace-ddown-arrow.ca1a3dcb.svg";